import React from 'react';
import { AlertBanner, Box } from '@saviynt/design-system';
import cx from 'classnames';

import { useIspmErrorContext } from '../../context/ispmErrorContext';
import { ErrorTypeEnum } from '../../data-layer/types';
import { useInvertedLocalize } from '../../utils/localization';
import { invertedMessages } from '../../utils/messages';

import './AlertBannerContainer.css';

export enum AlertBannerKindEnum {
  DownloadData = 'download',
  SystemError = 'systemError',
}

function AlertBannerContainer({ kind }: { kind: AlertBannerKindEnum }) {
  const { ispmErrorState, updateIspmErrorState } = useIspmErrorContext();

  const l = useInvertedLocalize(invertedMessages);

  function getAlertBanner() {
    switch (kind) {
      case AlertBannerKindEnum.DownloadData:
        return (
          <AlertBanner
            kind='high'
            colorTheme='Information'
            title='Generating Data'
            description='Your data is being generated and will be available in the Downloads section of your profile menu when finished.'
            onCancel={() => {
              // Update as per the your scenario
            }}
            isVisible={false}
          />
        );
      case AlertBannerKindEnum.SystemError:
        return (
          <div role='alert' aria-label={l('System Error Alert')}>
            <Box
              className={cx(
                ispmErrorState.errorType === ErrorTypeEnum.System
                  ? 'Ispm-AlertBanner-emphasisWrapper'
                  : ''
              )}>
              <AlertBanner
                colorTheme='Critical'
                title={l('Service temporary unavailable.')}
                description={l(
                  'There was an error while processing your prompt. Please try again later'
                )}
                onCancel={() => {
                  updateIspmErrorState('errorType', undefined);
                }}
                isColonVisible={false}
                isVisible={ispmErrorState.errorType === ErrorTypeEnum.System}
              />
            </Box>
          </div>
        );
      default:
        return null;
    }
  }

  return <>{getAlertBanner()}</>;
}

export default AlertBannerContainer;
